import React, { useState, useEffect } from "react";
import { GoogleApiWrapper } from "google-maps-react";
import AccessTimeFilledIcon from "@mui/icons-material/AccessTimeFilled";
import { query } from "../../services/object";

import { Combobox, ComboboxInput } from "@reach/combobox";
import "@reach/combobox/styles.css";
import List from "@mui/material/List";
import ListItemButton from "@mui/material/ListItemButton";
import ListItemIcon from "@mui/material/ListItemIcon";
import ListItemText from "@mui/material/ListItemText";
import ListSubheader from "@mui/material/ListSubheader";
import Divider from "@mui/material/Divider";
import useOnclickOutside from "react-cool-onclickoutside";
import SearchIcon from "@mui/icons-material/Search";
import { Box } from "@mui/material";
import Grid from "@mui/material/Unstable_Grid2/Grid2";
import "./style.css";

const MarketSearch = (props) => {
    return (
        <span className="GoogleAutoComplete">
            <PlacesAutocomplete props={props} />
        </span>
    );
};

const PlacesAutocomplete = ({ props, setZoom }) => {
    const [isMenuOpen, setIsMenuOpen] = useState(false);
    const [markets, setMarkets] = useState([]);
    const [originalMarkets, setOriginalMarkets] = useState([]);
    const [value, setValue] = useState("");

    let lastLocation = localStorage.getItem("lastLocation");
    if (lastLocation) {
        lastLocation = JSON.parse(lastLocation);
    }

    useEffect(() => {
        getMarkets();
    }, []);

    const getMarkets = async () => {
        let marketsResult = await query("market", "getAllRecords");
        if (marketsResult.isSuccess) {
            let marketsData = marketsResult.data;
            marketsData.sort((a, b) => a.order - b.order);
            setMarkets(marketsData);
            setOriginalMarkets(marketsData);
        }
    };

    /**
     * This method will show the menue
     * @param {*} value
     */
    const showMenu = (value) => {
        if (!value || markets?.length === 0) {
            setIsMenuOpen(true);
        }
    };
    /**
     * This method will hanlde the combobox input change
     * @param {*} value
     */
    const handleSearchLocation = (value) => {
        if (value) {
            let markets = originalMarkets.filter((item) => item.name.toLowerCase().indexOf(value.toLowerCase()) > -1);
            setMarkets(markets);
        } else {
            setMarkets(originalMarkets);
        }
        setValue(value);
    };

    const ref = useOnclickOutside(() => {
        // When user clicks outside of the component, we can dismiss
        // the searched suggestions by calling this method
        setTimeout(() => {
            setIsMenuOpen(false);
        }, 500);
    });

    /**
     * This method will handle the Recent location
     * @param {*} index
     */
    const handleRecentLocation = (index) => {
        props.onSelect(markets[index]);
    };

    /**
     * This method will display the menu list
     * @returns
     */
    const displayMenuList = () => {
        return (
            <div className="list">
                <List sx={{ width: "100%", maxWidth: 450 }} component="nav" aria-labelledby="nested-list-subheader">
                    {markets?.length > 0 && (
                        <>
                            <ListSubheader style={{ borderRadius: "10px", lineHeight: "22px" }}>
                                {"Markets"}
                            </ListSubheader>
                            {markets.map((value, index) => (
                                <>
                                    <ListItemButton key={index} onClick={() => handleRecentLocation(index)}>
                                        <ListItemIcon>
                                            <AccessTimeFilledIcon sx={{ color: "#2E8BC0" }} />
                                        </ListItemIcon>
                                        <ListItemText primary={value.name} />
                                    </ListItemButton>
                                </>
                            ))}
                        </>
                    )}
                </List>
            </div>
        );
    };

    return (
        <div ref={ref}>
            <Combobox>
                <Box sx={{ position: "relative" }}>
                    <Grid sx={{ display: "flex" }}>
                        <Grid item>
                            <ComboboxInput
                                value={value}
                                onChange={(e) => handleSearchLocation(e.target.value)}
                                className="combobox-input combobox"
                                placeholder="Search Market"
                                onClick={(e) => showMenu(e.target.value)}
                            />
                            <Box className="search-icon" sx={{ mt: "1px" }}>
                                <SearchIcon></SearchIcon>
                            </Box>
                        </Grid>
                    </Grid>

                    {isMenuOpen && displayMenuList()}
                </Box>
            </Combobox>
        </div>
    );
};

export default MarketSearch;
